module.exports = __webpack_public_path__ + "img/thumb-ichsan-mufti.54face6c.png";